import React from 'react';
import { fmtQty, piecesWholeFrom, toNum } from '../../class/util';

// Blocco quantità condiviso da Posizionamento / Rientro / Correzione.
//
// INTERI: N colli × PEZZI PER COLLO → i pezzi totali sono DERIVATI e in sola lettura
// (feedback cliente: la quantità che si digita è quella per collo, non il totale).
// COLLI APERTI: si aggiungono uno per click, ognuno col SUO residuo. Ogni collo aperto è una RIGA
// a sé (feedback cliente: tracciare i singoli colli aperti) e colli diversi hanno residui diversi,
// quindi non c'è un "numero di colli" né un totale: c'è un campo per collo.
//
// La coppia colli+pz/collo resta su UNA riga (.pkg-row-pair): un terzo campo schiaccerebbe i tre
// sotto il target touch di 48px sui terminali in portrait. Il derivato va su riga propria, dove
// legge come risultato.
const QtyBlock = ({
    title,
    colliWhole, perColloWhole,
    opens = [], onAddOpen, onChangeOpen, onRemoveOpen,
    onChange,
    hint,          // nodo/stringa: suggerimento sulle pezzature già presenti in cella
    warn,          // nodo/stringa: avviso (es. rientro oltre il netto prelevato, giacenza non uniforme)
    perColloLabel = 'Pezzi per collo',
    bare = false,  // true = senza wrapper .pkg-card (quando è già dentro una card)
}) => {
    const piecesWhole = piecesWholeFrom(colliWhole, perColloWhole);
    const piecesOpen = opens.reduce((sum, v) => sum + toNum(v), 0);
    const total = piecesWhole + piecesOpen;
    const Wrapper = bare ? React.Fragment : 'div';
    const wrapperProps = bare ? {} : { className: 'pkg-card' };

    return (
        <Wrapper {...wrapperProps}>
            <div className="pkg-section-title">{title}</div>

            <div className="pkg-row pkg-row-pair">
                <div className="pkg-field">
                    {/* I COLLI sono interi per definizione (colonna INT in DB) → tastierino numerico. */}
                    <label>Colli interi</label>
                    <input inputMode="numeric" value={colliWhole} onChange={e => onChange('colliWhole', e.target.value)} placeholder="0" />
                </div>
                <div className="pkg-field">
                    {/* La PEZZATURA è DECIMAL(15,5): può essere frazionaria per davvero (componenti
                        a KG, righe legacy). `inputMode="numeric"` non mostra la virgola sul
                        tastierino del tablet, quindi il magazziniere non poteva digitarla. */}
                    <label>{perColloLabel}</label>
                    <input inputMode="decimal" value={perColloWhole} onChange={e => onChange('perColloWhole', e.target.value)} placeholder="0" />
                </div>
            </div>
            <div className="pkg-derived-line">Pezzi interi (tot.): {fmtQty(piecesWhole)}</div>
            {hint ? <div className="pkg-hint">{hint}</div> : null}

            {/* Ogni collo aperto è UNA riga con il SUO residuo: colli diversi hanno residui
                diversi, quindi serve un campo per collo e si aggiungono uno per click. */}
            <div className="pkg-row">
                <div className="pkg-field">
                    <label>Colli aperti</label>
                    <span className="pkg-hint">Ogni click aggiunge un collo aperto: diventerà una riga di giacenza con il suo residuo.</span>
                    <button className="btn-sm btn-indietro" onClick={onAddOpen}>+ Aggiungi collo aperto</button>
                </div>
            </div>
            {/* Campo + Rimuovi su UNA riga (vedi .pkg-row-open). */}
            {opens.map((v, i) => (
                <div className="pkg-row pkg-row-open" key={i}>
                    <div className="pkg-field">
                        <label>Collo aperto {fmtQty(i + 1)} — pezzi residui</label>
                        <input className="pkg-int" inputMode="decimal" value={v}
                            onChange={e => onChangeOpen(i, e.target.value)} placeholder="0" />
                    </div>
                    <button className="btn-sm btn-indietro" onClick={() => onRemoveOpen(i)} title="Togli questo collo aperto">
                        Rimuovi
                    </button>
                </div>
            ))}

            <div className="pkg-derived-line">TOTALE: {fmtQty(total)} pz</div>
            {warn ? <div className="pkg-derived-line is-warn">{warn}</div> : null}
        </Wrapper>
    );
};

export default QtyBlock;
